// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UrcfH","title":"styles_title__d9qxs","description":"styles_description__lJAEO","buttonContainer":"styles_buttonContainer__Mwx2I"};